import styled from 'styled-components';
// const ReviewOrder = styled.div`
//   box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.08);
//   background-color: #ffffff;
//   padding: 0 20px;
//   min-width: 338px;
//   max-width: 500px;
//   position: sticky;
//   top: 96px;
//   height: fit-content;
//   @media only screen and (max-width: 970px) {
//     width: 100%;
//   }
// `;
const Heading = styled.p`
  color: #000000;
  line-height: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  Button {
    color: #00b3ff;
    background: #ffffff;
    font-size: 20px;
  }
`;

const To = styled.div`
  margin: 0 10px;
`;
const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  padding: 14px;
  border-radius: 3px;
  border: solid 1px #dadada;
  background-color: #ffffff;
`;

// const DateTime = styled.div``;
const DateTimeWrapper = styled.div`
  display: flex;
  @media only screen and (max-width: 575px) {
    flex-direction: column;
  }
`;
const TimeWrapper = styled.div`
    display: grid;
    grid-template-columns: auto 25px auto;
    grid-gap: 10px;
`
export {
  DateTimeWrapper,
  InputWrapper,
  Heading,
  To,
  TimeWrapper,
};
